import { render, staticRenderFns } from "./PaperlessManagement.vue?vue&type=template&id=250cb80e&scoped=true&"
import script from "./PaperlessManagement.vue?vue&type=script&lang=ts&"
export * from "./PaperlessManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PaperlessManagement.vue?vue&type=style&index=0&id=250cb80e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cb80e",
  null
  
)

export default component.exports